import React from "react";

const servicesList = [
  {
    id: 1,
    image: "./img/railway-consultancy.jpg",
    title: "Lifts & Hoists",
    section: "Section 28 • Factories Act 1948",
    description:
      "Statutory examination, load testing, and certification of passenger lifts, goods hoists, and material elevators.",
    deliverables: [
      "Periodic examination of ropes, sheaves, and gear",
      "Safety interlocks, switches, and governor tests",
      "Form 11 fitness certification",
    ],
  },
  {
    id: 2,
    image: "./img/drone-survey.jpg",
    title: "Lifting Machinery",
    section: "Section 29 • Factories Act 1948",
    description:
      "Testing, examination, and certification of cranes, derricks, tackles, chains, ropes, and hooks.",
    deliverables: [
      "Proof-load testing for Safe Working Load (SWL)",
      "Visual and non-destructive welding checks",
      "Statutory inspection records",
    ],
  },
  {
    id: 3,
    image: "./img/Energy.jpg",
    title: "Pressure Vessels",
    section: "Section 31 • Factories Act 1948",
    description:
      "Mandatory hydrostatic testing and certification of pressure vessels, air receivers, and boilers.",
    deliverables: [
      "Vessel wall thickness & integrity tests",
      "Safety valve and pressure gauge calibration",
      "PESO compliance checkups",
    ],
  },
  {
    id: 4,
    image: "./img/echosounderr.jpg",
    title: "Safety Audits",
    section: "Process Safety & DMP",
    description:
      "Comprehensive safety audits, hazard identification, risk assessments, and Disaster Management Plans.",
    deliverables: [
      "Process safety analysis (HAZOP & QRA)",
      "Emergency exit and fire protection reviews",
      "On-site/Off-site emergency drafting",
    ],
  },
];

const Services = () => {
  return (
    <div className="bg-slate-50 min-h-screen pb-24">
      {/* Minimal Header */}
      <div className="bg-slate-900 text-white py-12 md:py-16 text-center">
        <h1 className="text-2xl md:text-4xl font-extralight tracking-widest uppercase text-slate-100">
          Services
        </h1>
        <div className="w-16 h-0.5 bg-blue-500 mx-auto mt-3 mb-3"></div>
        <p className="text-slate-400 text-xs md:text-sm max-w-xl mx-auto px-4 font-light leading-relaxed">
          Authorized statutory testing, examinations, and compliance safety audits under the Factories Act 1948.
        </p>
      </div>

      {/* Minimal Grid */}
      <section className="max-w-6xl mx-auto px-4 md:px-8 mt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {servicesList.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              {/* Image Container */}
              <div className="h-56 relative bg-slate-100 overflow-hidden rounded-t-xl">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-500 rounded-t-xl"
                />
                <div className="absolute top-4 left-4 bg-slate-900/80 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full font-medium tracking-wide">
                  {service.section}
                </div>
              </div>

              {/* Content Panel */}
              <div className="p-8 flex-grow flex flex-col justify-between space-y-6">
                <div className="space-y-3">
                  <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
                    {service.title}
                  </h2>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="border-t border-slate-100 pt-5">
                  <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
                    Scope of Work
                  </h4>
                  <ul className="space-y-2">
                    {service.deliverables.map((item, idx) => (
                      <li key={idx} className="flex items-start text-xs text-slate-600 gap-2">
                        <span className="text-blue-500 font-bold">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
